import axios from 'axios'
import SearchUrlBuilder from '@/core/utils/SearchUrlBuilder'

class ServicoApiClient {

    async buscarTodos(filtros, paginacao) {
        const url = SearchUrlBuilder.buildAvanced(
            '/servico',
            filtros,
            paginacao
        )
        return axios.get(url)
    }

    async cadastrar(dados) {
        return axios.post('/servico/inserir/', dados)
    }

    async editar(dados) {
        return axios.put('/servico/atualizar/', dados)
    }

    async excluir(id) {
        return axios.delete(`/servico/deletar/${id}`)
    }

}

export default new ServicoApiClient()